/*
 * Peel — the colour dots on a collection card.
 *
 * Pressing one shows that colourway's photograph in the card it sits
 * under, so a shopper scanning a grid can see the case in the colour
 * they are after without opening it. Everything the swap needs — the
 * shot, the colour it is of, the link that lands on it — is on the dot
 * itself; snippets/peel-card-swatch.liquid puts it there.
 *
 * Delegated from the document rather than bound per card: the collection
 * grid replaces its whole section on every filter, sort and page change
 * (see the AJAX swap in peel-collection.js), which would drop any
 * listener sitting on the cards it replaced.
 *
 * Loaded on the collection and search templates — the two that render
 * this card — the same pair peel-collection.css is loaded for.
 */
(function () {
  function showShot(card, swatch) {
    /* The hover shot is a second img in the same box, so the main one is
       asked for by name rather than by being first in the box. */
    var img = card.querySelector('.peel-plp-card-media img:not([data-plp-hover-img])');
    var src = swatch.getAttribute('data-swatch-src');
    if (!img || !src) return false;

    /* srcset first: the other way round the browser starts a fetch on the
       src and then picks all over again once the candidates arrive. */
    img.srcset = swatch.getAttribute('data-swatch-srcset') || '';
    img.src = src;

    var alt = swatch.getAttribute('data-swatch-alt');
    if (alt) img.alt = alt;

    /* The card holds its shape from the image's own dimensions, so a
       colourway shot at a different size must bring its own along or the
       row jumps as it lands. */
    var width = swatch.getAttribute('data-swatch-width');
    var height = swatch.getAttribute('data-swatch-height');
    if (width && height) {
      img.setAttribute('width', width);
      img.setAttribute('height', height);
    }
    return true;
  }

  /* The hover shot follows the colourway too. A colour photographed only
     once carries none, and the card stops hovering rather than hovering
     to the picture of whichever colour it was showing before — the dot
     is hidden, not dropped, so pressing back to a colour that does have
     a second shot brings it straight back. Sections without the setting
     on have no hover image to find, and this does nothing. */
  function showHoverShot(card, swatch) {
    var img = card.querySelector('[data-plp-hover-img]');
    if (!img) return;

    var src = swatch.getAttribute('data-swatch-hover-src');
    if (!src) {
      img.hidden = true;
      return;
    }
    img.srcset = swatch.getAttribute('data-swatch-hover-srcset') || '';
    img.src = src;
    img.hidden = false;
  }

  /* The card's links follow its picture: a card showing Midnight that
     opens Bone answers a question nobody asked. The add-to-cart form is
     left alone — it is only rendered for products with no options to
     pick, which have no colour row to press. */
  function retarget(card, url) {
    if (!url) return;
    Array.prototype.forEach.call(
      card.querySelectorAll('a.peel-plp-card-media, a.peel-plp-card-name, a.peel-plp-add'),
      function (link) {
        link.href = url;
      }
    );
  }

  /* The ring moves to the dot that was pressed, so the card says which
     colourway its photograph is of. Every dot in the row is cleared,
     including the one the server rendered ringed on a filtered grid. */
  function markActive(card, swatch) {
    Array.prototype.forEach.call(card.querySelectorAll('.peel-plp-swatch'), function (dot) {
      var on = dot === swatch;
      dot.classList.toggle('is-active', on);
      if (dot.hasAttribute('data-plp-swatch')) {
        dot.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-plp-swatch]');
    if (!swatch) return;
    var card = swatch.closest('[data-card]');
    if (!card) return;

    event.preventDefault();
    if (!showShot(card, swatch)) return;
    showHoverShot(card, swatch);
    retarget(card, swatch.getAttribute('data-swatch-url'));
    markActive(card, swatch);
  });
})();
